import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Button, Snackbar, Radio, RadioGroup, FormControlLabel, FormControl } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import ContactDetailField from "../../../molecules/ContactDetailField";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import DescriptionIcon from "@mui/icons-material/Description";
import CommentIcon from "@mui/icons-material/Comment";
import GavelIcon from "@mui/icons-material/Gavel";
import StarIcon from "@mui/icons-material/Star";
import ExtensionIcon from "@mui/icons-material/Extension";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import { Bucket } from "../../../../api/config/apiConfig";
import MySignatureCanvas from "../../../molecules/signature_canvas";
import DynamicText from "../../../molecules/DynamicText";
import { useLocation } from "react-router-dom";

const CustomerFeedbackClient = () => {
  const [formContent, setFormContent] = useState({});
  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);
  const [isValid, setIsValid] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const getContent = () => {
    setIsLoading(true);
    setMediaKeysToSend([]);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);
        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);
        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);

  const updateContent = (data) => {
    setIsLoading(true);
    const body = {
      formContentId: formContentId,
      content: data ? data : formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: [],
    };
    updateFormContentPreview(
      surveyId,
      formId,
      email,
      token,
      body,
      formContentId
    )
      .then((res) => {
        if (data != undefined)
          setSnackbarMessage("Signature has been added successfully!");
        else
          setSnackbarMessage("Feedback has been updated successfully!");

        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);
        setIsLoading(false);
        setMediaKeysToSend([]);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);
        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }
        setIsLoading(false);
      });
  };

  const [uploadText1, setUploadText1] = useState("Upload Sign");
  const [isSignCanvas, setSignCanvas] = useState(false);
  const [whichSign, setWhichSign] = useState("");

  const uploadFile = async (file) => {
    setIsLoading(true);
    if (whichSign == "client") setUploadText1("Uploading...");

    const fd = new FormData();
    fd.append("image", file);

    imageUploadClientPreview(fd, surveyId, formId, email, token)
      .then((res) => {
        let values = { ...formContent };
        if (whichSign == "client") values.clientSign = res?.data?.data?.key;
        setFormContent(values);

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setIsLoading(false);
        setTimeout(() => {
          updateContent(values);
        }, 2000);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);
        setUploadText1("Upload Sign");
        setIsLoading(false);
      });
  };

  const RatingRow = ({ label, valueKey }) => (
    <div className="mb-4">
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>{label}</Typography>
      <FormControl component="fieldset" disabled={!isEdit}>
        <RadioGroup
          row
          name={valueKey}
          value={formContent?.[valueKey] || ""}
          onChange={(e) => {
             let values = { ...formContent };
             values[valueKey] = e.target.value;
             setFormContent(values);
          }}
        >
          {["Excellent", "Good", "Average", "Fair", "Poor"].map((option) => (
             <FormControlLabel key={option} value={option} control={<Radio />} label={option} />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );

  return (
    <>
      {isValid ? (
        <PremiumPublicLayout
          title="Customer Feedback Report"
          hideBackButton={true}
          actions={
            <div className="d-flex gap-3">
                {!isEdit && (
                    <Button
                    variant="contained"
                    onClick={() => {
                        setIsEdit(true);
                    }}
                    disabled={isLoading}
                    sx={{ 
                        textTransform: "none", 
                        borderRadius: "var(--radius-md)", 
                        padding: "10px 24px",
                        fontWeight: 700,
                        backgroundColor: "var(--primary-color)",
                        boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                        '&:hover': { backgroundColor: 'var(--primary-hover)' }
                    }}
                    startIcon={<NoteAltIcon />}
                    >
                    Edit Feedback
                    </Button>
                )}
                {isEdit && (
                    <Button
                    variant="outlined"
                    color="error"
                    onClick={() => {
                        getContent();
                        setIsEdit(false);
                    }}
                    disabled={isLoading}
                    sx={{ textTransform: "none", borderRadius: "var(--radius-md)", fontWeight: 700, padding: "10px 24px", border: "1px solid" }}
                    >
                    Cancel
                    </Button>
                )}
                {isEdit && (
                    <Button
                    variant="contained"
                    onClick={() => {
                        updateContent();
                    }}
                    disabled={isLoading}
                    sx={{ 
                        textTransform: "none", 
                        borderRadius: "var(--radius-md)", 
                        padding: "10px 32px",
                        fontWeight: 700,
                        backgroundColor: "var(--primary-color)",
                        boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
                        '&:hover': { backgroundColor: 'var(--primary-hover)' }
                    }}
                    >
                    Submit Feedback
                    </Button>
                )}
            </div>
          }
        >
          {/* Customer Details */}
          <SectionHeader title="Customer Details" icon={<DescriptionIcon />} />
          <PremiumCard sx={{ marginBottom: "32px" }}>
            <Row>
              <Col md={6}>
                 <ContactDetailField
                  label="Client Name"
                  isEdit={isEdit}
                  type="text"
                  minWidth={"100%"}
                  value={formContent?.clientName}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.clientName = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Col>
              <Col md={6}>
                 <ContactDetailField
                  label="Job Type"
                  isEdit={isEdit}
                  type="text"
                  minWidth={"100%"}
                  value={formContent?.jobType}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.jobType = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Col>
            </Row>
          </PremiumCard>

          {/* Ratings */}
          <SectionHeader title="Service Ratings" icon={<StarIcon />} />
          <PremiumCard sx={{ marginBottom: "32px" }}>
             <RatingRow label="How our administration team responded to any queries" valueKey="adminResponse" />
             <RatingRow label="The professionalism of our moving crew" valueKey="crewProfessionalism" />
             <RatingRow label="How our moving crew responded to all your requirements" valueKey="crewResponse" />
             <RatingRow label="The total moving experience" valueKey="totalExperience" />
             
             <Typography variant="h6" className="mt-4 mb-3" sx={{color: '#1976d2'}}>Origin Services Rating</Typography>
             <RatingRow label="Their administration process" valueKey="originAdmin" />
             <RatingRow label="Their moving crew" valueKey="originCrew" />
          </PremiumCard>

          {/* Additional Info */}
          <SectionHeader title="Additional Information" icon={<ExtensionIcon />} />
          <PremiumCard sx={{ marginBottom: "32px" }}>
             <div className="mb-4">
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Would you recommend SHELOZON?</Typography>
                <FormControl component="fieldset" disabled={!isEdit}>
                  <RadioGroup
                    row
                    name="recommendation"
                    value={formContent?.recommendation || ""}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.recommendation = e.target.value;
                      setFormContent(values);
                    }}
                  >
                    <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value="No" control={<Radio />} label="No" />
                    <FormControlLabel value="Not Sure" control={<Radio />} label="Not Sure" />
                  </RadioGroup>
                </FormControl>
             </div>

             <ContactDetailField
                label="Impressive Employees (Name)"
                isEdit={isEdit}
                type="text"
                minWidth={"100%"}
                value={formContent?.impressedEmployee}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.impressedEmployee = e.target.value;
                  setFormContent(values);
                }}
              />

             <Typography variant="h6" className="mt-4 mb-3" sx={{color: '#1976d2'}}>Services Offered (Yes/No)</Typography>
             
             {[
               {label: "Maid Services", key: "maidServices"},
               {label: "Utilities connection", key: "utilities"},
               {label: "Handyman Services", key: "handyman"}
             ].map((service) => (
                <div key={service.key} className="d-flex align-items-center mb-2">
                   <Typography variant="body1" sx={{width: '200px'}}>{service.label}</Typography>
                   <FormControl component="fieldset" disabled={!isEdit}>
                    <RadioGroup
                      row
                      name={service.key}
                      value={formContent?.[service.key] === "yes" ? "yes" : (formContent?.[service.key] === "no" ? "no" : "")}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values[service.key] = e.target.value;
                        setFormContent(values);
                      }}
                    >
                      <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                      <FormControlLabel value="no" control={<Radio />} label="No" />
                    </RadioGroup>
                  </FormControl>
                </div>
             ))}

          </PremiumCard>

          {/* Remarks */}
          <SectionHeader title="Remarks" icon={<CommentIcon />} />
          <PremiumCard sx={{ marginBottom: "32px" }}>
            <div className="mb-4">
              <DynamicText
                label="Remarks"
                textAreaLabel="Remarks"
                isEdit={isEdit}
                value={formContent?.remarks}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.remarks = e.target.value;
                  setFormContent(values);
                }}
              />
            </div>
          </PremiumCard>

          {/* Signatures */}
          <SectionHeader title="Authorization" icon={<GavelIcon />} />
          <PremiumCard sx={{ marginBottom: "32px" }}>
            <Row className="mt-4">
              <Col sm={6} className="mt-4">
                <div style={{ height: "90px" }} className="d-flex justify-content-center align-items-end">
                   {/* Team Leader / Admin Sign - Read only for client? Or logic says client signs and maybe team leader too? 
                       In FeedbackForm, it lists Team Leader and Client.
                       In Admin logic, they can upload both.
                       Usually client only signs Client Signature.
                       I will display Team Leader sig if present (read only) and allow Client to sign Client Sig.
                   */}
                   {formContent?.adminSign?.trim()?.length > 0 ? (
                      <img src={`${Bucket}${formContent?.adminSign}`} height={80} alt="Team Leader Sign" />
                   ) : (
                      <Typography variant="body2" color="textSecondary">No Signature</Typography>
                   )}
                </div>
                <p className="text-center">{"_______________________________"}</p>
                <p className="my-1 text-center"><b>{"Team Leader"}</b></p>
              </Col>
              <Col sm={6} className="mt-4">
                <div style={{ height: "90px" }} className="d-flex justify-content-center align-items-end">
                  {formContent?.clientSign?.trim()?.length == 0 ? (
                    <>
                      {isEdit && (
                        <div className="d-flex justify-content-center align-items-end">
                          <label htmlFor="uploadSign" className="active-btn ms-2 w-200 d-flex align-items-center justify-content-center cursor-pointer btn">
                            {uploadText1}
                          </label>
                          <input type="button" hidden id="uploadSign" name="uploadSign" onClick={() => { setWhichSign("client"); setSignCanvas(true); }} />
                        </div>
                      )}
                    </>
                  ) : (
                    <img src={`${Bucket}${formContent?.clientSign}`} height={80} alt="Client Sign" />
                  )}
                </div>
                <p className="text-center">{"_______________________________"}</p>
                <p className="my-1 text-center"><b>{"Client Signature"}</b></p>
              </Col>
            </Row>
          </PremiumCard>
        </PremiumPublicLayout>
      ) : (
        <div className="no-print">
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </div>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert elevation={6} variant="filled" severity={snackbarMessage?.includes("successfully") ? "success" : "error"} onClose={handleCloseSnackbar}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      {isSignCanvas && (
        <MySignatureCanvas
          open={isSignCanvas}
          onClose={() => {
            setSignCanvas(false);
          }}
          onSuccess={(file) => {
            if (!isLoading) uploadFile(file);
          }}
        />
      )}
    </>
  );
};

export default CustomerFeedbackClient;
